module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos-subcategoria/gastos-subcategoria.component.scss
// module id = ./src/app/gastos/gastos-subcategoria/gastos-subcategoria.component.scss
// module chunks = main